import { StyledButton } from '../../Basic/Button/Button.styles.mjs';
import Container from '../../Basic/Container/Container.mjs';
import { StyledHeading } from '../../Typography/Heading/Heading.mjs';
import styled from 'styled-components';

const offset = {
    md: '11%',
    lg: '8%',
    xxl: '12%'
};
const StyledHeroContainer = styled.a `
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    margin-bottom: -${offset.md};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    margin-bottom: -${offset.lg};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xxl}) {
    margin-bottom: -${offset.xxl};
  }
`;
const StyledImageContainer = styled.div `
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  max-height: 824px;
`;
const StyledImageUnderlayContainer = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;

  &::after {
    display: block;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: ${props => props.theme.gradients.heroImageUnderlay};
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    min-height: 125%;
    min-width: 125%;
    filter: blur(15px);
  }
`;
const StyledThumbnailContainer = styled.div `
  width: 100%;
  max-width: 1520px;
  overflow: hidden;
`;
const StyledThumbnailInnerContainer = styled.div `
  position: relative;
  padding-bottom: 56.302%;
  width: 100%;

  &::after {
    display: block;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: ${props => props.theme.gradients.imageOverlay};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    &::after {
      background: ${props => props.theme.gradients.heroImageOverlay};
    }
  }
`;
const StyledInfo = styled(Container) `
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 1rem;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    padding-bottom: ${offset.md};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    padding: 0 3.75rem ${offset.lg};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xxl}) {
    padding-bottom: ${offset.xxl};
  }

  ${StyledButton} {
    width: 100%;

    @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
      width: max-content;
    }
  }

  ${StyledHeading} {
    color: ${props => props.theme.colors.white};
    text-shadow: 0 0 4px ${props => props.theme.colors.black}80;
    margin-top: 0;
    font-size: ${props => props.theme.typography.headings.h3.fontSize};
    line-height: ${props => props.theme.typography.headings.h3.lineHeight};
    margin-bottom: 0;

    @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
      margin-bottom: 1rem;
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
      font-size: ${props => props.theme.typography.headings.h2.fontSize};
      line-height: ${props => props.theme.typography.headings.h2.lineHeight};
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
      font-size: ${props => props.theme.typography.headings.h1.fontSize};
      line-height: ${props => props.theme.typography.headings.h1.lineHeight};
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
      width: 75%;
    }
  }
`;

export { StyledHeroContainer, StyledImageContainer, StyledImageUnderlayContainer, StyledInfo, StyledThumbnailContainer, StyledThumbnailInnerContainer };
//# sourceMappingURL=Hero.styles.mjs.map
